import moment from 'moment';

import { JournalDto } from '~modules/journal/model';

type ActiveSessionProps = {
	journal: JournalDto;
};

export function ActiveSession({ journal }: ActiveSessionProps) {
	return (
		<div className="session-active">
			<div>Время сканирования: {moment(journal.date).format('DD.MM.YYYY HH:mm')}</div>
			{/* <button onClick={onDone}>Новая сессия</button> */}
		</div>
	);
}
